// extracted by mini-css-extract-plugin
export var amazonIcon = "homeIntro-module--amazonIcon--HwVQ9";
export var bio = "homeIntro-module--bio--TcaAv";
export var container = "homeIntro-module--container--aMQiA";
export var homeIntro = "homeIntro-module--homeIntro--2mU6u";
export var profile = "homeIntro-module--profile--HETp1";